import { t } from '@ankr.com/common';
import { ChainID } from '@ankr.com/chains-list';

import {
  TAC_TESTNET_SPB_COSMOS_GRPC_PATH,
  TAC_TESTNET_SPB_COSMOS_REST_PATH,
  TAC_TESTNET_SPB_TENDERMINT_REST_PATH,
  TAC_TESTNET_SPB_TENDERMINT_RPC_PATH,
  TAC_TESTNET_TURIN_COSMOS_GRPC_PATH,
  TAC_TESTNET_TURIN_COSMOS_REST_PATH,
  TAC_TESTNET_TURIN_TENDERMINT_REST_PATH,
  TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH,
} from 'modules/chains/constants';

import { root } from '../../../const';

const tendermintJSONRPCTestnets = [
  TAC_TESTNET_SPB_TENDERMINT_RPC_PATH,
  TAC_TESTNET_TURIN_TENDERMINT_RPC_PATH,
];

const tendermintRESTTestnets = [
  `http/${TAC_TESTNET_SPB_TENDERMINT_REST_PATH}`,
  `http/${TAC_TESTNET_TURIN_TENDERMINT_REST_PATH}`,
  `premium-http/${TAC_TESTNET_SPB_TENDERMINT_REST_PATH}`,
  `premium-http/${TAC_TESTNET_TURIN_TENDERMINT_REST_PATH}`,
];

const cosmosRESTTestnets = [
  `http/${TAC_TESTNET_SPB_COSMOS_REST_PATH}`,
  `http/${TAC_TESTNET_TURIN_COSMOS_REST_PATH}`,
  `premium-http/${TAC_TESTNET_SPB_COSMOS_REST_PATH}`,
  `premium-http/${TAC_TESTNET_TURIN_COSMOS_REST_PATH}`,
];

const cosmosGRPCTestnets = [
  `http/${TAC_TESTNET_SPB_COSMOS_GRPC_PATH}`,
  `http/${TAC_TESTNET_TURIN_COSMOS_GRPC_PATH}`,
  `premium-http/${TAC_TESTNET_SPB_COSMOS_GRPC_PATH}`,
  `premium-http/${TAC_TESTNET_TURIN_COSMOS_GRPC_PATH}`,
];

export const renderTacTitle = (url: string, isLoggedIn: boolean) => {
  const pathArr = new URL(url).pathname
    .split('/')
    .filter(pathItem => !!pathItem);

  const pathArrLength = pathArr.length;

  const path = pathArr
    .slice(0, isLoggedIn ? pathArrLength - 1 : pathArrLength)
    .join('/');

  if (tendermintRESTTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.tendermint-rest-title`);
  }

  if (tendermintJSONRPCTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.tendermint-rpc-title`);
  }

  if (cosmosRESTTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.cosmos-rest-title`);
  }

  if (cosmosGRPCTestnets.includes(path as ChainID)) {
    return t(`${root}.endpoints.cosmos-grpc-title`);
  }

  return t(`${root}.endpoints.evm-json-rpc-title`);
};
